import React from "react";
import IntegrationActivityLog from "./IntegrationActivityLog";

export default function IntegrationLog() {
  return (
    <div className="bg-white rounded-2xl shadow-md p-6">
      <div className="mb-4">
        <div className="font-semibold text-slate-800 text-lg">All Integration Activity</div>
        <div className="text-sm text-slate-500 mt-0.5">
          Logs for every integration on your account — filter by integration, severity, or category.
        </div>
      </div>
      <IntegrationActivityLog />
    </div>
  );
}
